import script from "./UpdateAttendeeConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateAttendeeConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./UpdateAttendeeConfirmation.vue?vue&type=style&index=0&id=a61201f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a61201f4"]])

export default __exports__